import { useEffect } from 'react';
import { safeTrack } from '../../utils/analytics';
// import { CartAddition } from '../../utils/cart-tracking';

interface ButtonWithListener {
  element: Element;
  handler: (event: Event) => void;
}

const StartCheckout: React.FC<{
  store: string;
  products: string;
  provider: string;
  customer: string;
}> = ({ store, products, provider, customer }) => {
  useEffect(() => {
    const buttonsWithListeners = new Set<ButtonWithListener>();

    const transformProducts = (productsString: string) => {
      return productsString.split(',').map((productId) => ({
        id: parseInt(productId.trim(), 10),
        quantity: 1,
      }));
    };

    const findAndAttachListeners = () => {
      const cssSelectors =
        'button[class*="checkout"], a[class*="checkout"], button[class*="-checkout-"], button[class*="-checkout"], salla-mini-checkout-widget, #cart-submit, salla-button[id="cart-submit"], .cart-submit-wrap salla-button';

      const xpathSelector = `//*[not(self::script) and not(self::style)][contains(text(), 'الدفع') or contains(text(), 'الشراء') or contains(text(), 'checkout') or contains(text(), 'Checkout') or contains(text(), 'purchase') or contains(text(), 'Purchase')]`;
      const xpathResults = document.evaluate(
        xpathSelector,
        document,
        null,
        XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
        null,
      );

      const checkoutButtons = [...document.querySelectorAll(cssSelectors)];
      for (let i = 0; i < xpathResults.snapshotLength; i++) {
        const element = xpathResults.snapshotItem(i);
        if (element instanceof Element) {
          // Check if the element is a span and use its parent if so
          const targetElement =
            element.tagName.toLowerCase() === 'span'
              ? element.parentElement
              : element;
          if (targetElement) {
            checkoutButtons.push(targetElement);
          }
        }
      }

      console.log('checkoutButtons', checkoutButtons);

      checkoutButtons.forEach((button) => {
        if (
          Array.from(buttonsWithListeners).some((b) => b.element === button)
        ) {
          return;
        }

        const clickHandler = (event: Event) => {
          event.stopPropagation();

          // const existingData = sessionStorage.getItem('alfinder_cart_additions');
          // const cartAdditions: CartAddition[] = existingData
          //   ? JSON.parse(existingData)
          //   : [];
          safeTrack('started_checkout', {
            storeId: store,
            provider: provider,
            // products: cartAdditions.map((item) => item.productId),
            products: transformProducts(products),
            customer,
          });
          console.log('started_checkout', {
            storeId: store,
            provider: provider,
            products: transformProducts(products),
            customer,
          });
          // sessionStorage.setItem(
          //   'alfinder_checkout_products',
          //   JSON.stringify(products),
          // );
          // if (cartAdditions.length > 0) {
          //   // Count products from each source
          //   const sourceCounts = cartAdditions.reduce(
          //     (acc, item) => ({
          //       recommendations:
          //         acc.recommendations +
          //         (item.source === 'recommendations' ? 1 : 0),
          //       searchPage:
          //         acc.searchPage + (item.source === 'search_page' ? 1 : 0),
          //       searchBar: acc.searchBar + (item.source === 'search_bar' ? 1 : 0),
          //     }),
          //     {
          //       recommendations: 0,
          //       searchPage: 0,
          //       searchBar: 0,
          //     },
          //   );

          //   safeTrack('alfinder_initiated_checkout', {
          //     storeId: store,
          //     provider: provider,
          //     products: cartAdditions.map((item) => item.productId).join(', '),
          //     productsFromRecommendations: sourceCounts.recommendations,
          //     productsFromSearchPage: sourceCounts.searchPage,
          //     productsFromSearchBar: sourceCounts.searchBar,
          //     totalAlfinderProducts: cartAdditions.length,
          //   });

          //   console.log('alfinder_initiated_checkout', {
          //     storeId: store,
          //     provider: provider,
          //     products: cartAdditions.map((item) => item.productId).join(', '),
          //     productsFromRecommendations: sourceCounts.recommendations,
          //     productsFromSearchPage: sourceCounts.searchPage,
          //     productsFromSearchBar: sourceCounts.searchBar,
          //     totalAlfinderProducts: cartAdditions.length,
          //   });
          //   sessionStorage.removeItem('alfinder_cart_additions');
          // }
        };

        button.addEventListener('click', clickHandler);
        buttonsWithListeners.add({ element: button, handler: clickHandler });
      });
    };

    // Initial search
    findAndAttachListeners();

    // Poll for new buttons every 300ms for up to 1.5 seconds
    let attempts = 0;
    const maxAttempts = 5; // 5 * 300ms = 1.5 seconds

    const intervalId = setInterval(() => {
      findAndAttachListeners();
      attempts++;

      if (attempts >= maxAttempts || buttonsWithListeners.size > 0) {
        clearInterval(intervalId);
      }
    }, 300);

    return () => {
      clearInterval(intervalId);
      buttonsWithListeners.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
    };
  }, []);

  return <></>;
};

export default StartCheckout;
